import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { _t } from "app/i18n/i18n";
import ReactDatePicker from "react-datepicker";
import { FaIcon } from "lib/FaIcon";
import { toUTCYYYYMMDD } from "lib/dateUtils";
import queryString from "query-string";
import { useQueryParams } from "lib/hooks/useQueryParams";
import { useHistory } from "react-router";

export const CompanySearchForm = () => {
  const qs = useQueryParams();
  const [date, setDate] = useState(qs.date ? new Date(qs.date) : new Date());
  const [assetClass, setAssetClass] = useState(qs.assetClass || "EQ");
  const [tickers, setTickers] = useState(qs.tickers || "");
  const [submitted, setSubmitted] = useState(false);
  const history = useHistory();

  const onSubmit = (e) => {
    e.preventDefault();
    const utcDate = toUTCYYYYMMDD(date);
    const qs = queryString.stringify({ date: utcDate, assetClass, tickers });
    setSubmitted(true);
    history.push({ search: qs });
  };

  return (
    <Form
      className="p-3 mb-3 border-right clearfix d-sm-flex flex-row justify-content-between shadow"
      onChange={() => setSubmitted(false)}
      onSubmit={onSubmit}
    >
      <Form.Group className="m-3 w-150px">
        <Form.Label className="d-block ">{_t("Date")}</Form.Label>
        <ReactDatePicker
          name="date"
          dateFormat={"yyyy-MM-dd"}
          selected={date}
          onChange={(date) => {
            setDate(date);
            setSubmitted(false);
          }}
          maxDate={new Date()}
          minDate={new Date("1995-01-01")}
          style={{ width: "150px" }}
          width={150}
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          className="p-2 border width-inherit"
        />
      </Form.Group>
      <Form.Group className="m-3">
        <Form.Label className="d-block ">{_t("Asset Class")}</Form.Label>
        <Form.Check
          id="EQ"
          name="assetClass"
          type="radio"
          label={_t("Equity")}
          value="EQ"
          onChange={() => setAssetClass("EQ")}
          checked={assetClass === "EQ"}
        />
        <Form.Check
          id="FI"
          name="assetClass"
          type="radio"
          label={_t("Fixed Income")}
          value="FI"
          onChange={() => setAssetClass("FI")}
          checked={assetClass === "FI"}
        />
      </Form.Group>
      <Form.Group className="m-3 flex-grow-1">
        <Form.Label>
          {_t("Company or Ticker")}
          <QuestionMark title={_t("Disclosure msg")} />
        </Form.Label>
        <Form.Control
          name="tickers"
          as="textarea"
          value={tickers}
          onChange={(e) => setTickers(sanitize(e.target.value))}
          placeholder={_t("Disclosure msg")}
          className="tickers-input"
        />
      </Form.Group>
      <Form.Group className="d-flex align-items-center m-3 pt-2">
        <Button
          aria-label="more information"
          variant="primary px-5"
          type="submit"
          disabled={tickers.length < 2 || submitted}
        >
          {_t("Search")}
        </Button>
      </Form.Group>
    </Form>
  );
};

const QuestionMark = ({ title }) => (
  <FaIcon icon="fa fa-question-circle text-info ml-1" align="" title={title}></FaIcon>
);

const sanitize = (str) => str.replace(/[\\[\]'\\(\\)\\{\\}:;%!]+/g, "");
